import React from 'react';
import { TopNavigation } from './TopNavigation';
import { AlertCircleIcon, WifiOffIcon } from 'lucide-react';
interface MainLayoutProps {
  children: React.ReactNode;
  isOffline: boolean;
}
export const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  isOffline
}) => {
  return <div className="flex flex-col h-screen bg-gray-100" data-id="element-2757">
      {/* Top Navigation Bar */}
      <TopNavigation data-id="element-2758" />
      {/* Main Content */}
      <div className="flex-1 overflow-y-auto" data-id="element-2759">
        {/* Offline Indicator */}
        {isOffline && <div className="bg-amber-50 border-l-4 border-amber-400 p-4 m-4 flex items-center" data-id="element-2760">
            <WifiOffIcon className="h-5 w-5 text-amber-500 mr-2" data-id="element-2761" />
            <div data-id="element-2762">
              <p className="text-sm text-amber-700 font-medium" data-id="element-2763">
                You are currently offline
              </p>
              <p className="text-xs text-amber-600" data-id="element-2764">
                Changes will be synced when you reconnect
              </p>
            </div>
          </div>}
        {/* Page Content */}
        <div className="p-6" data-id="element-2765">{children}</div>
      </div>
    </div>;
};